webpackJsonp([115072139617743],{

/***/ 425:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/corning.md absPath of file >>> MarkdownRemark","html":"<p>Corning</p>","fields":{"slug":"/corning/"},"frontmatter":{"date":"April 09, 2018","title":"Corning","cover":"/img/coffee-gear.png","meta_title":"Corning","meta_description":"Test","username":"corninghustle","tags":["Corning"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/corning.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---corning-6e50c601da6f9cddc64b.js